import * as ko from 'knockout';

import { OrganizationTypeData, organizationTypesApi } from '../api/organizations';
import { OrganizationType } from '../models/organization_type';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import { ListRequestParams } from '../api/request';
import { session } from '../session';
import { addChangelogListAction, addChangelogAction } from './changelog';
import { Action } from '../components/basic_widgets';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { translate } from '../i18n_text';
import { canViewChangelog, reactListTablesEnabled } from '../permissions';
import { GridView } from '../utils/grid_view';
import {
  OrganizationTypesListPage,
  OrganizationTypesListProps,
  OrganizationTypesListQuery,
  OrganizationTypesListRow,
} from 'react-islands';

let template = require('raw-loader!../../templates/organization_types.html').default;

class OrganizationTypesScreen implements ListLoaderDelegate<OrganizationTypeData, OrganizationType> {
  canCreate = session.isAtLeastEditor();
  // Same rule as the legacy user-log columns.
  showUserLog = canViewChangelog(null);

  listActions = ko.observableArray<ListHeaderAction>([]);

  newOrganizationTypesTable = reactListTablesEnabled();

  private view = new GridView('organization-types');

  tableProps = ko.pureComputed<OrganizationTypesListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
    showUserLog: this.showUserLog,
  }));

  constructor(params: { filters: unknown }) {
    if (this.canCreate) {
      this.listActions.push({
        title: i18n.t('Add')(),
        icon: 'add_circle',
        href: '/organization_types/new/',
        tooltipTitle: i18n.t('Add Organization Types')(),
      });
    }

    this.listActions.push(...addChangelogListAction('organization_type'));

    if (this.newOrganizationTypesTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return organizationTypesApi.list(params);
  }

  private fetchPage = (query: OrganizationTypesListQuery): Promise<OrganizationTypesListPage> =>
    this.view.fetchListPage(query, organizationTypesApi.list, 'name_prefix', this);

  toRow = (entity: OrganizationType, data: OrganizationTypeData): OrganizationTypesListRow => ({
    id: entity.id(),
    name: translate(entity.nameJson()),
    url: session.toTenantPath(this.getEditUrl(entity)),
    publicTypeName: entity.publicTypeName(),
    createdByName: data.created_by_user_name || '',
    modifiedByName: data.modified_by_user_name || '',
    actions: delegateActions(this, entity, this.view.reload),
  });

  instantiate(data: OrganizationTypeData) {
    return new OrganizationType(data);
  }

  getEditUrl(entity: OrganizationType) {
    return entity.editUrl();
  }

  remove(id: string) {
    return organizationTypesApi.remove(id);
  }

  canRemove(entity: OrganizationType) {
    return entity.canEdit();
  }

  getActions(entity: OrganizationType): Action[] {
    return addChangelogAction('organization_type', entity.id());
  }
}

export let organizationTypes = {
  name: 'organization-types',
  viewModel: OrganizationTypesScreen,
  template: template,
};

ko.components.register(organizationTypes.name, organizationTypes);
